<template>
  <main>
    <thing-group-header></thing-group-header>
    <thing-group></thing-group>
  </main>
</template>

<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import thingIcon from '../../components/Svg/things/thing'
  import thingGroupHeader from '../../components/Pages/Things/Headers/thingsList/thingListHeader'
  import thingGroup from '../../components/Pages/Things/Things/thingFirstLevel'
  import {pageSettings} from "../../mixins/utils/pageSettings";

  export default {
    name: 'thingsVirtual',
    mixins: [tokenAndRoute, loaderMixin, pageSettings],
    components: {
      thingIcon,
      thingGroupHeader,
      thingGroup
    },
    computed: {
      ...mapState({
        thing: state => state.things.device,
        projects: state => state.projects.allProjects,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned
      })
    },
    methods: {
      ...mapActions({
        //getDevice: 'things/getDevice'
      }),
      ...mapMutations({
        setDirName: 'things/SET_DIR_NAME',
        setDevice: 'things/SET_DEVICE',
      }),
      getDevice() {
        let device
        let getDeviceData = (arr) => {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].devices.length > 0) {
              for (let j = 0; j < arr[i].devices.length; j++) {
                if (arr[i].devices[j].id === Number(this.routeId)) {
                  device = arr[i].devices[j]
                  break;
                }
              }
            }
            if (arr[i].items.length > 0) {
              getDeviceData(arr[i].items)
            }
          }
        }

        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].items.length > 0) {
            getDeviceData(this.projects[i].items)
          }
        }

        let finish = () => {
          this.setDevice(device)
          this.setRouteName(this.thing.name);
          document.title = `OmniioTh | Вещь ${this.thing.name}`;
        }

        if (device) {
          finish()
        } else {
          device = this.allThingsFromGetOwned.find(device => device.id === Number(this.routeId))
          if (device) {
            device.permission_level = 4
            finish()
          }
        }
      },
    },
    watch: {
      async routeId(val) {
        this.showLoader();
        await  this.getDevice(Number(val));
        this.setRouteName(this.thing.name);
        this.setDirName(this.thing.name);
        document.title = `OmniioTh | Вещь ${this.thing.name}`
        this.hideLoader();
      },
      projects() {
        this.getDevice(Number(this.routeId));
      },
      allThingsFromGetOwned() {
        this.getDevice(Number(this.routeId));
      }
    },
    mounted() {
      this.setDirName(this.thing.name);
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const token = localStorage.getItem('token');
        const param = vm.$route.params.id;
        vm.showLoader();
        await vm.getDevice(param);
        vm.setFullSidebar(false);
        vm.setLinkName('things');
        vm.setRouteName(vm.thing.name);
        vm.setDirName(vm.thing.name);
        document.title = `OmniioTh | Вещь ${vm.thing.name}`;
        vm.hideLoader()
      })
    }
  }
</script>
